<div style="display: flex; align-items: center;justify-content: end;margin: 20px 25px;">
    <img mat-dialog-close="" src="/icons/close-kb.svg" width="20px" alt="">
</div>
<mat-dialog-content>
    <div class="content">
        <div id="webshopNA">
            <p></p>
            <h2>Terms of Use</h2><br><br>By installing the new component software, you are about
            to change the O.E. factory set software parameters for a safety-related system. You
            need to fully understand the implications of making changes to the Bendix safety
            systems by thoroughly reviewing all available information including but not limited
            to the information located at B2Bendix.com so you can make the best-educated
            decision as it applies to the safe operation of your commercial vehicle.<p></p>
        </div>
    </div>
    <div class="accept-btn-outer text-right" style="float: inline-end;"><button class="btn btn-blue btn-block"
            style="border-radius: 0px !important;" (click)="service.PrivacyTerms = true" mat-dialog-close>
            {{'common.register_accept_message'|cxTranslate}}</button>
    </div>
</mat-dialog-content>